<template>
  <div>
    <!-- todo 需要数据验证 -->
    <van-nav-bar
      class="backBox"
      title="故障处理"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="create-time">
          <div>
            <span class="msgBeforeTit">上报时间：</span>
            <span class="msgAfterText">{{ createTime }}</span>
          </div>

          <div v-if="roomName" class="room-name">
            <span class="msgBeforeTit">{{h5Config.textCfg.roomName}}号：</span>
            <span class="msgAfterText"> {{ roomName }}</span>
           </div>
        </div>

        <div class="content-wrap">
          <div class="content-title msgBeforeTit">故障说明：</div>
          <span class="content-txt msgAfterText">{{ content }}</span>
        </div>

        <div class="pic-title">
          <span class="msgBeforeTit">故障图片：</span>
          <span class="msgAfterText"> {{ images.length ? '' : '无' }}</span>

          </div>

        <div v-if="images.length" class="image-list-parent">
          <div v-for="item in images" :key="item.id" class="image-item">
            <img class="full-image" mode="aspectFill" :src="item" />
          </div>
        </div>
        <van-divider />
        <!-- <van-divider v-if="images.length" /> -->

        <div v-if="reply_time">
          <!-- <div class="line"></div> -->
          <div class="reply-wrap">
            <div class="msgBeforeTit">故障维修：</div>
            <div class="radio-group-wrap">
              <van-radio-group class="radioBox" v-model="radioVal"  :disabled="true" direction="horizontal">
                <van-radio icon-size="12px" :name="haddleOption[0].value"><span class="msgAfterText">{{ haddleOption[0].name}}</span></van-radio>
                <van-radio icon-size="12px" :name="haddleOption[1].value"><span class="msgAfterText">{{ haddleOption[1].name}}</span></van-radio>
                <van-radio icon-size="12px" :name="haddleOption[2].value"><span class="msgAfterText">{{ haddleOption[2].name}}</span></van-radio>
              </van-radio-group>
            </div>
          </div>
          <div>
           <span class="msgBeforeTit">时间：</span> <span class="msgAfterText">{{ reply_time }}</span>
          </div>
          <div class="content-bottom-wrap">
            <span class="msgAfterText">{{ comment||'暂无回复' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {},

      id: null,

      images: [],
      reply_time: '',
      result: '',
      comment: '',
      roomName: '',
      radioVal: 1,
      haddleOption: [
        { value: 1, name: '未解决', checked: 'true' },
        { value: 2, name: '已解决' },
        { value: 3, name: '不解决' }
      ]

    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.queryList()
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    queryList () {
      const para = {
        id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.queryFaultMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            const images = []
            let replyTime = ''
            if (res.reply_time) {
              replyTime = utils.formatZHYMDHM(utils.formatDate(res.reply_time))
            }
            let result = res.result || 1

            if (res.result) {
              if (res.result === this.haddleOption[2].value) {
                result = 3
              } else if (res.result === this.haddleOption[1].value) {
                result = 2
              } else {
                result = 1
              }
            }
            const that = this
            this.haddleOption.forEach(function (item) {
              const _this = that
              if (item.value === result) {
                item.checked = true

                _this.radioVal = item.value
              } else {
                item.checked = false
              }
            })
            if (Array.isArray(res.pic_url_list)) {
              res.pic_url_list.forEach(function (item, i) {
                images.push(api.getPicUrl(item))
              })
            }

            // 赋值
            this.createTime = utils.formatZHYMDHM(utils.formatDate(res.create_time))
            this.content = res.content
            this.reply_time = replyTime
            this.result = res.result

            this.comment = res.comment ? res.comment : '暂无回复'
            this.roomName = res.room_name
            this.images = images
            if (replyTime) {
              this.readMag()
            }
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

    .pic-title {
      margin-top: 0.625rem;
    }
    .image-list-parent {
      margin-top: 0.9375rem;
      // margin-left: 0.875rem;
      // margin-right: 0.875rem;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .image-item {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
      margin-right: 0.3125rem;
      margin-bottom: 0.3125rem;
      background-color: #d8d8d8;
      .full-image {
        width: 100%;
        height: 100%;
      }
    }
  }
  .reply-wrap{
      width: 100%;
display: flex;
justify-content: space-between;
 .radio-group-wrap{
  width: 100%;
   flex: 1;
    .radioBox{
    // width: 100%;
   }
  }

  }
  .content-bottom-wrap{
  margin-top: 7px;
  padding: 10px;
  border: #ccc solid 1px;
  border-radius: 4px;

}

}
</style>
